// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from './components/Layout';
import Home      from './pages/Home';
import Search    from './pages/Search';
import Likes     from './pages/Likes';
import Playlist  from './pages/Playlist';
import Profile   from './pages/Profile';
import Settings  from './pages/Settings';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index             element={<Home />}     />
          <Route path="search"     element={<Search />}   />
          <Route path="likes"      element={<Likes />}    />
          <Route path="playlist"   element={<Playlist />} />
          <Route path="profile"    element={<Profile />}  />
          <Route path="settings"   element={<Settings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;